
import React, {useState } from 'react'
import axios from 'axios';
import './signUp.css';

function SignUp({show, onClose, onSwitchToLogin}) {


    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    // const [role, setRole] = useState('user');

    const clearFields = () => {
        setName('');
        setEmail('');
        setPassword('');
        // setRole('user');
    }

    axios.defaults.withCredentials = true;
    const handleSubmit = (e) => {
        e.preventDefault();

        if(!name || !email || !password) {
            alert("Please fill in all fields");
            return;
        }

        // const endpoint = role === 'admin' ? '/admin/register' : '/register';

        axios.post(
            `http://localhost:3001/register`,
             {name, email, password}
            )
        .then(result => {
            alert("Registered Successfully");
            console.log(result);
            clearFields();
            onClose(); 
            onSwitchToLogin();
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent("showLoginModal"));
            }, 300);
        })
        .catch(err => {
            console.log(err);
            alert(err.response?.data?.error || "Registration failed");
        })
    }

    const handleClose = () => {
        clearFields();
        onClose();
    };

    const handleSwitchToLogin = () => {
        clearFields();
        onClose();
        onSwitchToLogin();
    };


    return (
        <div className="auth-modal-overlay justify-content-center" style={{ display: show ? 'flex' : 'none' }}>
          <div className="auth-modal-content">
            <span className="auth-close-btn" onClick={handleClose}>&times;</span>
            <h2 className="auth-modal-title">TATA CLiQ FASHION</h2>
    
            <div className='bg-white p-3 rounded w-250'>
                            <h2>Register</h2>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="email"><strong>Name</strong></label>
                                    <input type="text" 
                                    placeholder='Enter Name'
                                    value={name}
                                    className='form-control rounded-0'
                                    onChange={(e) => setName(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="email"><strong>Email</strong></label>
                                    <input type="email" 
                                    placeholder='Enter Email'
                                    value={email}
                                    className='form-control rounded-0'
                                    onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="email"><strong>Password</strong></label>
                                    <input type="password" 
                                    placeholder='Enter Password'
                                    value={password}
                                    className='form-control rounded-0'
                                    onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>
                                {/* <div className="mb-3">
                                <label htmlFor="role"><strong>Register as</strong></label>
                                <select 
                                    className='form-control rounded-0'
                                    value={role}
                                    onChange={(e) => setRole(e.target.value)}
                                >
                                    <option value="customer">User</option>
                                    <option value="admin">Admin</option>
                                </select>
                                </div> */}
                                <button type='submit' className='btn btn-success w-100 rounded-0'>Register</button>
                            </form>
                                <p>Already have an Account?</p>
                                <button
                                className='btn btn-default border w-100 bg-light rounded-0 text-decoration-none'
                                type='button'
                                onClick={handleSwitchToLogin}>
                                    Login
                                </button>
                        </div>
          </div>
        </div>
      )
}

export default SignUp